var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 382,
    y: 287,
    width: 86,
    height: 86
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-382 -287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M425.62 288C402.023 288 383 306.799 383 329.881 383 353.201 402.023 372 425.62 372 448.977 372 468 353.201 468 329.881 468 306.799 448.977 288 425.62 288M425.62 368.193C404.19 368.193 386.853 351.059 386.853 329.881 386.853 320.125 390.705 311.082 396.966 304.419 451.385 358.198 451.385 358.198 451.385 358.198 444.643 364.385 435.493 368.193 425.62 368.193M454.034 355.581C399.615 301.564 399.615 301.564 399.615 301.564 406.357 295.615 415.507 291.807 425.62 291.807 446.81 291.807 464.147 308.941 464.147 329.881 464.147 339.875 460.295 348.68 454.034 355.581",
    fill: "rgb(252,88,78)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.f596e6099017b37043629025a7a977b1.svg";
export { ForwardRef as ReactComponent };